import React, { useEffect, useState } from "react";
import { checkUserActiveStatus, makeSideBarActive } from "../../utils/ellowutils";
import * as CONSTANTS from "../../utils/CONSTANTS";
import SideMenu from "../sideMenu";
import DashboardHeader from "../topbar";
import Tab from "../../compopnents/tab";
import { TabStrip, TabStripSelectEventArguments } from "@progress/kendo-react-layout";
import Profile from "./profile";
import PasswordChange from "./passwordChange";
import GeneralSettings from "./generalsettings";
import Users from "./users";
import { addNewCompanyUser, edituserStatus, getCustomerForUserId, getUserDetailsForCustomer, listUserDetailsForCustomer, updateCompanySettings, updateRateInEmail, getLocations } from "./services";
import NotificationAlert from '../../compopnents/notification';
import mixpanelData, { viewedpageMixpanel } from "../../utils/mixpanel";

function CompanySettings() {
  const menu = makeSideBarActive(CONSTANTS.sideMenu, 3);
  const BreadcrumsValues = ["Settings"];
  const [selected, setSelected] = useState<number>(0);
  const customerId = localStorage.getItem('customerId') || ''
  const [userlist, setUserList] = useState<any>()
  const [userDetails, setUserDetails] = useState<any>()
  const userLoginId = localStorage.getItem('loginId') || ''
  const [profileData, setProfileData] = useState<any>()
  const [showRateInEmail, setshowRateInEmail] = useState<boolean>()
  const [defImage, setDefImage] = useState<string>()
  const [notification, setNotification] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [companyName, setCompanyName] = useState<any>()
  const [location, setLocation] = useState<any>()
  const [disableProfileSaveButton , setDisableProfileSaveButton] = useState<boolean>(false)


  useEffect(() => {
    
    getUsersList(customerId)
    getCompanyDetails(userLoginId)
    getLocationDetails(customerId)
    viewedpageMixpanel();

  },[customerId, userLoginId])
  
  const getCompanyDetails = (userLoginId: string) => {
    getCustomerForUserId(userLoginId).then((response) => {
      setProfileData(response.data[0])
      setshowRateInEmail(response.data[0].customer_metadata.showRateInEmail)
      setDefImage(response.data[0].customer_metadata.image)
      setCompanyName(response.data[0].customer_metadata.companyName)
    })
  }


  const getUsersList = (customerId: string) => {
    listUserDetailsForCustomer(customerId).then((response) => {
    setUserList(response.data)
   })
 }

 const getLocationDetails = (id: string) => {
  getLocations(id).then((resp: any) => {
    // if(resp && resp.status === 1){   
      setLocation(resp.data)
    // }
  } )
}

  const handleSelect = (e: TabStripSelectEventArguments) => {
    
    setSelected(e.selected) 
  }
  
  const Back = () => {
    setSelected((prev) => prev - 1)
  }
 
  const getUserDetails = (user_id: string) => {

      getUserDetailsForCustomer(user_id).then((response) => {
        setUserDetails(response.data[0].user_metadata)
      })
  }  
  const addNewUser = (data: any) => {

      addNewCompanyUser(data).then((response) => {
        if (response && response.status === 1) {
          mixpanelData('MT - User added', {
            'source': 'Customer adds a new user',
            "customerId":data && data.customerId,
            "userLoginId": data && data.userLoginId,
            "firstName":data && data.userMetadata && data.userMetadata.firstName,
            "lastName":data && data.userMetadata && data.userMetadata.lastName,
            "designation":data && data.userMetadata && data.userMetadata.designation,
            "email": data && data.userMetadata && data.userMetadata.email,
            "phone": data && data.userMetadata && data.userMetadata.phone && data.userMetadata.phone.toString()
          })
          
          mixpanelData(`New MT - Company User ${data.userId ? 'edited' : 'added'}`, {
            'distinct_id': localStorage.getItem('Email'),
            'Company id': data.customerId,
            'Company name': profileData && profileData.customer_metadata.companyName,
            'Company type': 'Hirer',
            "Name of the user": data && data.userMetadata && data.userMetadata.firstName + ' ' +  data.userMetadata.lastName,
            "Designation of the user":data && data.userMetadata && data.userMetadata.designation,
            "Email of the user": data && data.userMetadata && data.userMetadata.email,
            "Phone number": data && data.userMetadata && data.userMetadata.phone && data.userMetadata.phone.toString(),
            "Primary": response && response.data[0].primary ? 'True' : 'False',
            "Status": response && response.data[0]?.activeStatus && checkUserActiveStatus(response.data[0]?.activeStatus)
          })
          getUsersList(customerId)
          displayNotification()
        }
      })
  }

  const checkAction = (action: string) => {
    switch (action) {
      case 'delete':
        return 'deleted';
      case 'primary':
        return 'changed to primary';
      case 'disable':
        return 'disabled';
      case 'enable':
        return 'enabled'
   }
 }

  const editUserStatus = (data: any) => {
    edituserStatus(data).then((response) => {
      if (response && response.status === 1) {
        mixpanelData('MT - userStatus changed', {
          'source': 'Customer edits a users status',
          "action":data && data.status,
          "customerId": data && data.customerId,
          "userId": data && data.userId,
          "userLoginId": data && data.userLoginId
        }) 
        mixpanelData(`New MT - Company user ${checkAction(data.action)}`, {
            "distinct_id": localStorage.getItem('Email'),
            "Company name": response && response.data.companyName,
            "Company Id": data.customerId,
            "Company type": response && response.data.userType,
            "Name of the user": response && response.data.userName,
            "Email of the user": response && response.data.userEmail,
            "Phone number ": response && response.data.phoneNumber,
            "Designation of the user": response && response.data.designation,
            "Primary": response && response.data.primary ? 'Yes' : 'No',
            "Status"  : response && response.data.activeStatus && checkUserActiveStatus(response.data.activeStatus)
          })
  
        
        getUsersList(customerId)
      }
    })
  }

  const updateCompany = (data: any) => {
    
    setDisableProfileSaveButton(true)
    let body =  {
      "customerId": customerId,
      "customerMetadata": {
      "size":data.size.id,      
      "website": data.website,
      "workWithRemote": data.workWithRemote,
      "linkedinId": data.linkedinId,
      "profileUrl": data.profileUrl,
      "aboutCompany":data.description,
      "currencyType": data.currencyType,
      "roleDescription": data.roleDescription,
      'image':data.image,
      'googleLocations': data.googleLocations
  }
    }
    updateCompanySettings(body).then((response) => {
      if (response && response.status === 1) {
        mixpanelData('MT-Company settings updated', {
          'source': 'Customer updates company settings',
          "customerId": customerId,
          "size": data && data.size.name,      
          "website": data && data.website,
          "workWithRemote": data && data.workWithRemote === 0 ? 'Yes' : 'No',
          "linkedinId": data && data.linkedinId,
          "profileUrl": data && data.profileUrl,
          "aboutCompany": data && data.description,
          "currencyType": data && data.currencyType,
          "roleDescription": data && data.roleDescription,
        })
        mixpanelData('New MT - Settings - Company profile', {
          'distinct_id': localStorage.getItem('Email'),
          'Ellow profile link': data && data.profileUrl,
          'Linkedin': data && data.linkedinId,
          'Company id': customerId,
          'Company website': data && data.website,
          'Company size': data && data.size.name,
          'Preferred currency': data && data.currencyType,
          'location':'',
          'Company name': response && response.data[0].customer_metadata.companyName,
          'Company type': response && response.data[0].company_type === 1 ? 'Hirer' : response && response.data[0].company_type === 2 ? 'Provider' : 'Both'
        })
        getCompanyDetails(userLoginId)
        displayNotification()
        setDisableProfileSaveButton(false)
      }
    })
  }

  const showrateInMail = (data: any) => {
    updateRateInEmail(data).then((response) => {
      if (response && response.status === 1) {
        getCompanyDetails(userLoginId)
        mixpanelData('New MT - Settings - general section', {
          'distinct_id': localStorage.getItem('Email'),
          'Company name': response && response.data.customer_metadata.companyName,
          'Company Type': 'Hirer',
          'Rate enabled': data.showRateInEmail ? 'Yes' : 'No',
          'Company id': data.customerId
        })
      }
    })
  }

  const displayNotification = () => {
    setMessage('Details saved successfully')
    setNotification(true)
    setTimeout(() => {
      setNotification(false)
     }, 3000)  
  }

  const onClose = () => {
    setNotification(false)
  }


  return (
      <section className="dashboardWrapper">
         {notification && <NotificationAlert onClose={onClose } closable={true} >
          {message}
          </NotificationAlert> }
        <SideMenu menu={menu} />
        <div className="dashboardContent">
          <DashboardHeader searchChange={undefined} title={BreadcrumsValues} />
          <div className="companySettingsTab">
            <TabStrip selected={selected} onSelect={handleSelect}>
              <Tab title="Profile">
              <Profile clickHandler={updateCompany} defaultValues={profileData} locationChange={() => getLocationDetails(customerId)} defImage={defImage} location={location} disable={disableProfileSaveButton}/>
              </Tab>
              <Tab title="Users">
              <Users back={Back} getUser={getUserDetails} addNewUser={addNewUser} companyName={companyName} defImage={defImage} editUserStatus={editUserStatus} usersList={userlist} defaultValues={userDetails} />
              </Tab>
              <Tab title="General Settings">
              <GeneralSettings showrateInMail={showrateInMail} companyName={companyName} defaultValues={showRateInEmail} defImage={defImage} />
              </Tab>
              <Tab title="Change Password">
              <PasswordChange back={() => setSelected(0)} defImage={defImage} companyName={companyName} />
              </Tab>
            </TabStrip>
          </div>
        </div>
      </section> 
  );
}

export default CompanySettings;
